export default {
    slideSetup({ commit }, { i, duration = 1.7 } )
    {
        return new Promise(resolve => {
            commit('slideSet', { i })
            setTimeout(() => {
                resolve()
            }, duration * 1000)
        })
    },
    storySetup({ commit }, { i, duration = .0001 }) {
        return new Promise(resolve => {
            commit('storySet', { i })
            setTimeout(() => {
                resolve()
            }, duration * 1000)
        })
    },
}